// export : 끌여다 쓰기 위함

/**********************
 * 디바이스 타입 구분
 ***********************/
export function getDeviceType() {
  var agent = navigator.userAgent.toLowerCase()
  var type = 'Web'
  var mobileWebTxts = [
    'android',
    'phone',
    'iphone',
    'ipad',
    'ipod',
    'blackberry',
    'opera mini',
    'opera mobi',
    'windows ce',
    'iemobile',
    'nokia',
    'webos',
    'sonyericsson',
  ]

  if (agent.indexOf('morpheus') != -1) {
    //모피어스 일 때
    type = 'MobileApp'
  } else {
    //모바일 웹일때
    for (var i = 0; i < mobileWebTxts.length; i++) {
      var result = agent.indexOf(mobileWebTxts[i])
      if (result != -1) {
        type = 'MobileWeb'
        break
      }
    }
  }
  return type
}
